/**
 * @param size размер файла в байтах;
 * @returns размер файла в мегабайтах
 */
export const getFileSizeMB = (size: number) => (size / 1024 / 1024).toFixed(2);
